module.exports = __webpack_public_path__ + "static/media/cancer-ON.0e1114cb.png";